import { HttpRequestResponse } from '../models/web/http-request-response';
import axiosPrivate from '../models/axios/axios-private';
import {
  GET_ACTIVITIES_FEES_ENDPOINT,
  GET_ACTIVITIES_FEES_FOR_MEMBERSHIP_FEE_BY_MEMBER_ID_ENDPOINT,
  GET_MEMBERSHIP_FEES_ENDPOINT
} from '../constants';
import { AxiosError, AxiosResponse } from 'axios';
import { MembershipFeesResponse } from '../models/web/membership-fee-response';
import { ActivitiesFeesByMemberResponse } from "../models/activities-fees-by-member-response";
import { MemberProductStatus } from '../models/periodic-product-payment';
import { getEndpointResponse } from '../utils/endpoint-response';

export const getMembershipFeesByMember = async (memberId: string): Promise<HttpRequestResponse<MembershipFeesResponse>> => {
  const response: AxiosResponse | AxiosError = await axiosPrivate
    .get(GET_MEMBERSHIP_FEES_ENDPOINT.replace('{MemberId}', memberId))
    .catch((err: AxiosError): AxiosError => err);

  return getEndpointResponse(response);
}

export const getActivitiesFeesByMember = async (memberId: string): Promise<HttpRequestResponse<ActivitiesFeesByMemberResponse>> => {
  const response: AxiosResponse | AxiosError = await axiosPrivate
    .get(GET_ACTIVITIES_FEES_ENDPOINT.replace('{MemberId}', memberId))
    .catch((err: AxiosError): AxiosError => err);

  return getEndpointResponse(response);
}

export const getActivityFeesForMembershipFeeByMemberId = async (memberId: string, membershipFeeId: string): Promise<HttpRequestResponse<MemberProductStatus[]>> => {
  const response: AxiosResponse | AxiosError = await axiosPrivate
    .get(GET_ACTIVITIES_FEES_FOR_MEMBERSHIP_FEE_BY_MEMBER_ID_ENDPOINT
      .replace('{MemberId}', memberId)
      .replace('{MembershipFeeId}', membershipFeeId))
    .catch((err: AxiosError): AxiosError => err);

  return getEndpointResponse(response);
}
